import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { addReactError } from '@datadog/browser-rum-react';
import React from 'react';

const logToDatadogLogs = (error: Error, context: Record<string, any>) => {
  if (datadogLogs) {
    datadogLogs.logger.error(error.message || 'Error', context, error);
  }
};

/**
 * Log an error to both Datadog RUM and Datadog Logs with the same context.
 * Only logs if running on the client side.
 * Handles cases where one or both SDKs may not be initialized.
 *
 * @param error - The error object to log
 * @param context - Context object with additional metadata
 */
export const logErrorToDatadog = (error: Error, context: Record<string, any>) => {
  if (typeof window === 'undefined') return;

  if (datadogRum) {
    datadogRum.addError(error, context);
  }

  logToDatadogLogs(error, context);
};

export const logErrorBoundaryToDatadog = (error: Error, errorInfo: React.ErrorInfo) => {
  if (typeof window === 'undefined') return;

  if (datadogRum) {
    addReactError(error, errorInfo);
  }

  logToDatadogLogs(error, {
    source: 'error_boundary',
    component_stack: errorInfo.componentStack || undefined,
  });
};
